function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

/**
 * Clamps a number within a specified range.
 *
 * @param num - The number to clamp.
 * @param min - The minimum value in the range.
 * @param max - The maximum value in the range.
 * @return The clamped number.
 */
export function clamp(num: number, min: number, max: number): number {
  return Math.min(Math.max(num, min), max)
}
